import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Typography from '@mui/material/Typography';
import { InfoCard, CopyTextButton } from '@backstage/core-components';
import { useEntity } from '@backstage/plugin-catalog-react';

function CodeBlock({ text }: { text: string }) {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1,
        my: 1,
        backgroundColor: 'rgba(0,0,0,0.04)',
        borderRadius: 1,
        p: 1,
      }}
    >
      <Typography
        component="pre"
        variant="body2"
        sx={{
          fontFamily: 'monospace',
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-all',
          flex: 1,
          m: 0,
        }}
      >
        {text}
      </Typography>
      <CopyTextButton text={text} />
    </Box>
  );
}

export function DnsRecordCard() {
  const { entity } = useEntity();
  const annotations = entity.metadata.annotations ?? {};

  if (annotations['gcp.com/service'] !== 'cloud-dns-record') {
    return null;
  }

  const details = (entity.spec?.gcpDetails ?? undefined) as
    Record<string, unknown> | undefined;

  const { recordType, ttl, rrdata } = (details ?? {}) as {
    recordType?: string;
    ttl?: number;
    rrdata?: string[];
  };

  return (
    <InfoCard title="DNS Record">
      <Box>
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mb: 2 }}>
          {recordType && (
            <Chip label={recordType} size="small" variant="outlined" />
          )}
          {ttl !== undefined && (
            <Chip label={`TTL: ${ttl}s`} size="small" variant="outlined" />
          )}
        </Box>

        {rrdata && rrdata.length > 0 && (
          <>
            <Typography variant="subtitle2">Record Data</Typography>
            {rrdata.map((value, i) => (
              // eslint-disable-next-line react/no-array-index-key
              <CodeBlock key={`${value}-${i}`} text={value} />
            ))}
          </>
        )}
      </Box>
    </InfoCard>
  );
}
